import React, { useState, useEffect } from "react";
import ImageCropper from "../imageCropper/ImageCropper";
import PredictionOutput from "../predictionOutput/predictionOutput";
import PrivacyPolicy from "../privacyPolicy/PrivacyPolicy";
import "../privacyPolicy/privacyPolicy.css";
import { handleSubmitImage, uploadToFirebase } from "../../api/uploadImage";
import { setImage } from "../../slices/image";
import { useSelector, useDispatch } from "react-redux";
import { setCropMode, setZoom } from "../../slices/cropTools";
import { Form } from "react-bootstrap";
import "./upload.css";
// import { setModel } from "../../slices/model";
import { loadModel } from "../../assets/predictor/predictor";
import { allowedImgTypes } from "../../constants/variables";

function Upload() {
  const dispatch = useDispatch();

  // const [croppedImg, setCroppedImg] = useState(null);
  const image = useSelector((state) => state?.image?.image);
  // const model = useSelector((state) => state?.model?.model);
  const [model, setModel] = useState();
  const response = useSelector((state) => state?.image?.response);
  const loadingState = useSelector((state) => state?.image?.loadingState);
  const crop = useSelector((state) => state?.crop);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  // const getCroppedImg = (blob) => {
  //   // pass blob up from the ImageCropper component
  //   setCroppedImg(blob);
  // };
  useEffect(() => {
    loadModel(setModel);
  }, []);
  useEffect(() => {
    console.log(loadingState);
  }, [loadingState]);

  const handleChange = (event) => {
    const file = event.target.files[0];
    console.log(file.type);
    if (!file || !allowedImgTypes.includes(file.type)) {
      console.log("file upload error");
      return;
    }
    uploadToFirebase(file);
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const data = e.target.result;
      const image = new Image();
      image.src = data;
      // setCroppedAreaPixels(null);
      dispatch(
        setImage({
          file: file,
          imageData: image,
          URL: URL.createObjectURL(file),
          name: file.name,
        }),
      );
    };
    fileReader.readAsDataURL(file);
  };

  return (
    <div>
      <div className="upload-root page-max-width">
        <div className="upload-image-display">
          <p className="upload-image-selected-file-text">
            Selected file: {image.name}
          </p>
          <div className="image-container">
            {loadingState ? (
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            ) : !image.URL ? (
              <div className="image-placeholder">
                <svg
                  className="image-placeholder-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
                <p className="image-placeholder-text">
                  Upload a photo of your badge to get started
                </p>
              </div>
            ) : crop.cropOn ? (
              <ImageCropper
                setCroppedAreaPixels={setCroppedAreaPixels}
                inputImgURL={image.URL}
              ></ImageCropper>
            ) : (
              <img
                className="uploaded-image"
                src={image.URL}
                alt="Uploaded preview"
              ></img>
            )}
          </div>
        </div>

        <form
          onSubmit={(event) => {
            handleSubmitImage(
              event,
              image,
              crop.cropOn,
              model,
              croppedAreaPixels,
              dispatch,
            );
          }}
          name="image"
          encType="mutlipart/form-data"
          className="upload-image-selection"
        >
          <div className="privacy-checkbox-row">
            <input
              type="checkbox"
              id="privacy-agree"
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
            />
            <label htmlFor="privacy-agree">
              I agree to the{" "}
              <button
                type="button"
                className="privacy-link"
                onClick={() => setShowPrivacy(true)}
              >
                Terms &amp; Privacy Policy
              </button>
            </label>
          </div>

          <input
            type="file"
            name="image"
            accept="image/*"
            required
            onChange={handleChange}
            className="upload-image-button"
            disabled={!agreedToTerms}
          />
          <div className="upload-image-submit-button">
            <button
              type="submit"
              name="image"
              className="button-3"
              disabled={!image.file || !model || !agreedToTerms}
            >
              {model ? "Submit" : "Loading Model..."}
            </button>
            <div className="crop-controls-container">
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={crop.cropOn}
                label="Crop Image"
                onChange={(e) => {
                  dispatch(setCropMode(!crop.cropOn));
                }}
              />
              <Form.Label>Zoom</Form.Label>
              <Form.Range
                value={crop.zoom}
                min={1}
                max={3}
                step={0.05}
                onInput={(e) => dispatch(setZoom(e.target.value))}
                disabled={!crop.cropOn}
              />
            </div>
          </div>
        </form>
      </div>

      {response === null ? (
        <div></div>
      ) : (
        <PredictionOutput response={response}></PredictionOutput>
      )}

      {showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}
    </div>
  );
}

export default Upload;
